/**
 * Zwei Adressen, ein Frontend:
 *  - ProDash (Betrieb: https://prodash.rmnc.app/): die Sammlung der Dashboards.
 *  - Betriebstagebuch (Betrieb: https://btb.rmnc.app/): das Terminal an der Anlage, frei
 *    aufrufbar bis zur Chipleser-Ansicht, und darunter /verwaltung mit eigener Anmeldung.
 * Ohne VITE_TERMINAL_URL (lokal) liegt der Betriebstagebuch-Bereich unter /terminal derselben
 * Adresse.
 */
export const TERMINAL_URL = (import.meta.env.VITE_TERMINAL_URL as string | undefined) ?? ""

export const IST_TERMINAL_HOST = !!TERMINAL_URL && new URL(TERMINAL_URL).host === window.location.host

/** Pfad des Betriebstagebuch-Bereichs innerhalb dieser Adresse (für Router-Links). */
export const BTB_PFAD = IST_TERMINAL_HOST ? "" : "/terminal"

/** Vollständige Adresse der Betriebstagebuch-Verwaltung (für Weiterleitungen von ProDash). */
export const VERWALTUNG_URL = TERMINAL_URL
  ? `${TERMINAL_URL.replace(/\/$/, "")}/verwaltung`
  : `${import.meta.env.BASE_URL}terminal/verwaltung`
